var Entities = require('Entities');
var Lookups = EY.Consultation.Lookups;

module.exports.run = function (options) {
    var approvers = new Entities.Approvers(options.approvers.reject({ upn: '' }));
    var record = options.record;
    var approver = approvers.first();

    if (approver) {
        record.set({
            approverGroupId: approver.get('approverGroupId'),
            assignedTo: approver.get('upn'),
            assignedToGivenName: approver.get('givenName'),
            statusTypeId: Lookups.StatusType.ReviewApproval
        });
    }
};


// WEBPACK FOOTER //
// ./js/Modules/Record/Action/RecordActionSubmit.js